import {html, css, LitElement, ref, createRef, svg } from 'lit'


const dotsLoader = css`
    .dots-loader {
        display: block;
        width: 10px;
        height: 10px;
        background: black;
        color: white;
        border-radius: 50%;
        box-shadow: 20px 0,-20px 0;
        animation: dots-u8fzftmd 1s infinite linear alternate;
    }

    @keyframes dots-u8fzftmd {
       0% {
          box-shadow: 20px 0,-20px 0;
          background: black;
       }

       33% {
          box-shadow: 20px 0,-20px 0 black;
          background: black;
       }

       66% {
          box-shadow: 20px 0 black,-20px 0;
          background: white;
       }
    }
`

const backIcon = svg`
<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="15" cy="15" r="15" fill="#F3F3F3"/>
<path d="M10.5859 15.4375L15.8359 20.6875L14.5 22L7 14.5L14.5 7L15.8359 8.3125L10.5859 13.5625H22V15.4375H10.5859Z" fill="#1C1B1F"/>
</svg>
`

const uploadIcon = svg`
<svg width="21" height="27" viewBox="0 0 21 27" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.5003 19.9583L15.667 14.7916L13.8587 12.9833L11.792 14.9853V9.62492H9.20866V14.9853L7.14199 12.9833L5.33366 14.7916L10.5003 19.9583ZM2.75033 26.4166C2.03991 26.4166 1.43175 26.1636 0.925846 25.6577C0.419944 25.1518 0.166992 24.5437 0.166992 23.8333V8.33325L7.91699 0.583252H18.2503C18.9607 0.583252 19.5689 0.836203 20.0748 1.34211C20.5807 1.84801 20.8337 2.45617 20.8337 3.16659V23.8333C20.8337 24.5437 20.5807 25.1518 20.0748 25.6577C19.5689 26.1636 18.9607 26.4166 18.2503 26.4166H2.75033ZM2.75033 23.8333H18.2503V3.16659H9.01491L2.75033 9.43117V23.8333Z" fill="#FF8412"/>
</svg>
`


export class MobileAdminOrder extends LitElement {

    $orderPreview = createRef()
    $printer = createRef()

    connectedCallback() {
        super.connectedCallback()

        BX.ajax.runAction('uad:shop.api.customer.getAll', {
            data: {},
        }).then(resp => {
            if (resp && resp.data) {
                this.allClients = resp.data["ALL"]
                this.currentClient = resp.data["CURRENT"]

                if (this.allClients) {
                    this.index = FlexSearch.Index({preset: "performance", tokenize: "forward"})
                    for (let user of this.allClients) {
                        this.index.add(user["ID"], `${user["LAST_NAME"]} ${user["NAME"]}`)
                    }
                }
                this.requestUpdate()
            }
        }).catch(err => {
            console.error(err) 
        })

        this.addEventListener("search.reset", () => {
            this.found = null
            this.requestUpdate()
        })

        this.addEventListener("search", evt => {
            let foundIds = this.index.search(evt.detail)
            if (foundIds.length) {
                this.found = this.allClients.filter(client => foundIds.includes(client["ID"]))
                this.requestUpdate()
            }
            this.requestUpdate()
        })

        this.addEventListener("select", evt => {
            if (evt.detail) {
                this.selected = evt.detail
                this.requestUpdate()
                
                BX.ajax.runAction('dz:content.api.order.preview', {
                    data: {
                        target: this.selected["ID"]
                    },
                }).then(resp => {
                    if (resp && resp.data) {
                        this.order = Object.values(resp.data)
                        this.requestUpdate()
                    }
                }).catch(err => {
                    console.error(err) 
                })
            }
        })
    }

    render() {

        let result = []

        result.push(html`
            <div class="panel">
                <button @click=${this.hidePanel}>${backIcon}</button>
            </div>
            <div class="title">Выберите пользователя</div>
            ${ this.allClients ? 
                html`<mobile-client-dropdown .values=${this.found || this.allClients} .current=${this.currentClient["ID"]}></mobile-client-dropdown>` : 
                html`<div class="dots-loader"></div>`
            }
        `)

        if (this.selected) {
            let orderInfo = [],
                total     = 0

            if (this.order) {
                for (let item of this.order) {
                    total += Number(item.price) * Number(item.quantity)
                    orderInfo.push(html`
                        <div class="item">
                            <div class="brand">${item.brand}</div>
                            <div class="article">${item.article}</div>
                            <div class="name">${item.name}</div>
                            <div class="amount">${Number(item.price).toLocaleString()} * ${item.quantity}</div>
                        </div>
                    `)
                }
            }
            
            result.push(html`
                <div class="order-preview" part="order-preview" ${ref(this.$orderPreview)}>
                    <div class="panel">
                        <button @click=${() => {this.selected = null; this.requestUpdate()}}>${backIcon}</button>
                        ${this.order ? html`<button class="download-btn" @click=${this.downloadOrder}>${uploadIcon}</button>` : ``}
                    </div>
                    <iframe ${ref(this.$printer)} style="display: none"></iframe>
                    <div class="title">Заказ на клиента</div>
                    <div class="client">
                        <div class="name">${this.selected["LAST_NAME"]} ${this.selected["NAME"]}</div>
                        <div class="mail">${this.selected["EMAIL"]}</div>
                    </div>
                    ${ this.order ? 
                        html`<div class="items">${orderInfo}</div>`: 
                        html`<div class="dots-loader"></div>`
                    }
                    <div class="total">Итого ${total.toLocaleString()}</div>
                    <button class="order-btn" @click=${this.makeOrder}>Оформить</button>
                </div>
            `)
        }
        return result
    }

    hidePanel() {
        this.classList.remove("active")
        this.dispatchEvent(new CustomEvent("hidePanel", {composed: true}))
    }

    makeOrder() {
        let orderButton = this.$orderPreview.value.querySelector(".order-btn")
        orderButton.innerHTML = `<div class="dots-loader" style="filter: invert()"></div>`

        BX.ajax.runAction('dz:content.api.order.make', {
            data: {
                target: this.selected["ID"],
                custom_data: {}
            },
        }).then(resp => {
            if (resp && resp.data) {
                if (resp.data) {
                    this.$orderPreview.value.innerHTML = `
                        <div class="title">Заказ ${resp.data} сформирован</div>  
                    `
                    let btn = document.createElement("button")
                    btn.innerText = `Понятно`
                    btn.classList.add("order-btn")
                    btn.addEventListener("click", () => {
                        this.order = null
                        this.selected = null
                        window.location.href = "/personal/orders/"
                        this.dispatchEvent(new CustomEvent("hidePanel", {composed: true}))
                    })
                    this.$orderPreview.value.appendChild(btn)
                }
            }
        }).catch(err => {
            console.error(err) 
        })
    }


    downloadOrder() {
        if (this.order && this.$printer.value) {
            let p = this.$printer.value,
                total = 0,
                page = []
                

            page.push(`<h3 style="margin-bottom: 50px">Заказ на клиента : <span style="font-weight: normal">${this.selected["LAST_NAME"]} ${this.selected["NAME"]}</span></h3>`)
            page.push(`<hr>`)

            for (let item of this.order) {                
                let ab = `${item.brand} ${item.article}`
                page.push(`
                    <div class="item">
                        <h4>
                            <span style="text-transform: uppercase">${ab}</span>
                        </h4>
                        ${ item.name.trim().toLowerCase() != ab.trim().toLowerCase() ? `<div>${item.name}</div>` : `<br>`}
                        <div style="margin-top: 5px">${Number(item.price).toLocaleString()} руб * ${item.quantity} шт</div>
                        <hr>
                    </div>
                `)
                total += Number(item.price) * Number(item.quantity)
            }

            page.push(`<h2 style="float: right">Итого ${total.toLocaleString()}</h2>`)

            page.push(`
                <style>
                    body {
                        font-family: sans-serif;
                    }

                    hr {
                        border: none;
                        border-bottom: solid #0002 1px;
                    }

                    h4 {
                        margin-bottom: 5px;
                    }
                </style>
            `)


            p.contentWindow.document.open();
            p.contentWindow.document.write(page.join('\n'));
            p.contentWindow.document.close();
            p.contentWindow.print()
        }
    }

    static get styles() {
        return [
            dotsLoader,
            css`
            :host {
                display: flex;
                position: fixed;
                top: 0px;
                left: 100vw;
                width: 100vw;
                height: calc(100dvh - 60px);
                flex-direction: column;
                gap: 10px;
                z-index: 10;
                background: white;
                transition: 0.2s;
                padding: 20px;
            }

            :host(.active) {
                left: 0px;
            }

            .title {
                font-family: "Roboto Bold";
                font-size: 18px;
            }

            .dots-loader {
                margin: auto;
            }

            .order-preview {
                background: white;
                position: fixed;
                top: 0px;
                left: 0px;
                width: 100vw;
                height: calc(100dvh - 60px);
                padding-bottom: 100px;
                display: flex;
                flex-direction: column;
                gap: 20px;
                padding: 20px;
                font-size: 15px;
                box-sizing: border-box;
                color: black;
            }

            .client .name {
                font-family: "Roboto Bold";
                cursor: pointer;
            }

            .order-preview .items {
                display: flex;
                flex-direction: column;
                gap: 25px;
                overflow-y: auto;
            }

            .item {
                display: flex;
                flex-direction: column;
                gap: 5px;
            }

            .item .brand,
            .item .article {
                font-family: "Roboto Bold";
                font-size: 15px;
                text-transform: uppercase;
                color: #0006;
            }

            .item .name {
                font-size: 12px;
                margin-right: 30px;
            }

            .item .amount {
                font-family: "Roboto Bold";
                font-size: 20px;
            }

            .total {
                font-family: "Roboto Bold";
                font-size: 20px;
                text-align: right;
            }

            .order-btn {
                padding: 10px;
                width: 100%;
                background: linear-gradient(180deg, #FFFFFF 0%, #D6D6D6 116.3%);
                border: 1px solid #DDDDDD;
                border-radius: 6px;
                font-family: "Roboto Medium";
                font-size: 15px;
            }

            .panel button {
                appearance: none;
                background: none;
                border: none;
            }

            .panel .download-btn {
                float: right;
            }
        `]
    }
}

customElements.define('mobile-admin-order', MobileAdminOrder);


export class DesktopAdminOrder extends LitElement {
    connectedCallback() {
        super.connectedCallback()

        this.addEventListener("hidePanel", () => {
            this.classList.remove("active")
        })
    }


    render() {
        return html`
            <mobile-admin-order></mobile-admin-order>
            <div class="backdrop" @click=${() => this.classList.toggle("active")}></div>
        `
    }

    static get styles() {
        return css`
            :host {
                position: fixed;
                top: 0px;
                left: 0px;
                z-index: 100000;
                pointer-events: none;
                transition: 0.3s;
            }

            :host(.active) {
                pointer-events: all;
            }

            mobile-admin-order {
                width: 550px;
                height: 100vh;
                box-sizing: border-box;
                filter: drop-shadow(-10px 4px 56.8px rgba(0, 0, 0, 0));
            }

            mobile-admin-order::part(order-preview) {
                width: 550px;
                height: 100vh;
                box-sizing: border-box;
            }

            :host(.active) mobile-admin-order {
                left: calc(100vw - 550px);
                filter: drop-shadow(-10px 4px 56.8px rgba(0, 0, 0, 0.25));
            }

            .backdrop {
                width: 100vw;
                height: 100vh;
                background: #0000;
            }

            :host(.active) .backdrop {
                background: #0001;
            }   
        `
    }
}


customElements.define('desktop-admin-order', DesktopAdminOrder);